import React from 'react';
import { OrderChildRowHeader } from './OrderChildRowHeader';
import { OrderChildRowItem } from './OrderChildRowItem';

export const OrderChildRow = ({ order }) => {
    return (
        <React.Fragment>
            <OrderChildRowHeader />
            {order.items.map((item) => (
                <OrderChildRowItem key={item.id} item={item} />
            ))}
        </React.Fragment>
    );
};
